// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".labels{\n    color: gray !important;\n}\n\n.link{height: 40px !important}", "",{"version":3,"sources":["webpack://./src/rlinkPay/components/generateLinkPay/styles/labels.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA,MAAM,uBAAuB","sourcesContent":[".labels{\n    color: gray !important;\n}\n\n.link{height: 40px !important}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
